import { render, staticRenderFns } from "./gongdi.vue?vue&type=template&id=000101ca&scoped=true"
var script = {}
import style0 from "./gongdi.vue?vue&type=style&index=0&id=000101ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000101ca",
  null
  
)

export default component.exports